<template>
    <div class="hkpfs-form-container" v-loading="loading">
      <div class="main-title">
        <h2>HKPFS 奖学金申请表</h2>
      </div>
  
      <el-form 
        :model="formData" 
        :rules="rules" 
        ref="hkpfsForm" 
        label-position="top" 
        size="small"
      >
  
        <!-- SECTION 1: 志愿选择 -->
        <div class="form-section">
          <div class="section-title">1. 只能申请两个学校</div>
          
          <!-- 第一志愿 -->
          <el-card shadow="never" class="choice-card">
            <div slot="header" class="clearfix">
              <span class="choice-badge">第一志愿</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="学校" prop="choice1.university">
                  <!-- 修改：改为输入框 -->
                  <el-input v-model="formData.choice1.university" placeholder="请输入学校名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="专业" prop="choice1.program">
                  <el-input v-model="formData.choice1.program" placeholder="请输入专业"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="分支" prop="choice1.stream">
                  <el-input v-model="formData.choice1.stream" placeholder="请输入分支"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="导师" prop="choice1.supervisor">
                  <el-input v-model="formData.choice1.supervisor" placeholder="请输入导师姓名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
  
          <!-- 第二志愿 -->
          <el-card shadow="never" class="choice-card" style="margin-top: 15px;">
            <div slot="header" class="clearfix">
              <span class="choice-badge secondary">第二志愿</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="学校" prop="choice2.university">
                  <!-- 修改：改为输入框 -->
                  <el-input v-model="formData.choice2.university" placeholder="请输入学校名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="专业" prop="choice2.program">
                  <el-input v-model="formData.choice2.program"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="分支" prop="choice2.stream">
                  <el-input v-model="formData.choice2.stream"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="导师" prop="choice2.supervisor">
                  <el-input v-model="formData.choice2.supervisor"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-card>
        </div>
  
        <!-- SECTION 2: 核心信息 -->
        <div class="form-section">
          <div class="section-title">2. 港府研究信息确认</div>
          
          <el-form-item label="研究title" prop="researchTitle">
            <el-input v-model="formData.researchTitle" placeholder="请输入研究标题"></el-input>
          </el-form-item>
  
          <el-form-item prop="keywords">
            <span slot="label">
              Keywords <span class="limit-hint">100字符（含空格，10-20 words）</span>
            </span>
            <el-input 
              v-model="formData.keywords" 
              placeholder="请输入 Keywords"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
  
        <!-- SECTION 3: 文书要求 -->
        <div class="form-section">
          <div class="section-title">
            3. 文书要求
            <span class="subtitle">（1000 words）</span>
          </div>
  
          <!-- 3.1 -->
          <el-form-item prop="vision.reasons">
            <span slot="label" class="question-label">
              1) 希望在港攻读博士学位的原因
              <span class="limit-hint">（2000字符约230words）</span>
            </span>
            <el-input 
              type="textarea" 
              :rows="5" 
              v-model="formData.vision.reasons" 
              maxlength="2000" 
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 3.2 -->
          <el-form-item prop="vision.career">
            <span slot="label" class="question-label">
              2) 长期职业规划、毕业后的职业目标和发展兴趣
              <span class="limit-hint">（2000字符约230words）</span>
            </span>
            <el-input 
              type="textarea" 
              :rows="5" 
              v-model="formData.vision.career" 
              maxlength="2000" 
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 3.3 -->
          <el-form-item prop="vision.contribution">
            <span slot="label" class="question-label">
              3) 申请者希望对发展研究领域及香港社会的贡献
              <span class="limit-hint">（2000字符约230words）</span>
            </span>
            <el-input 
              type="textarea" 
              :rows="5" 
              v-model="formData.vision.contribution" 
              maxlength="2000" 
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 3.4 -->
          <el-form-item prop="vision.other">
            <span slot="label" class="question-label">
              4) 其他与申请香港博士奖学金有关的说明
              <span class="limit-hint">（2000字符约230words）</span>
            </span>
            <el-input 
              type="textarea" 
              :rows="5" 
              v-model="formData.vision.other" 
              maxlength="2000" 
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
  
        <!-- SECTION 4: 格外问题 -->
        <div class="form-section">
          <div class="section-title">4. 格外问题</div>
  
          <!-- 4.1 -->
          <el-form-item prop="research.experience">
            <span slot="label" class="question-label">
              1. 请描述您在研究项目中的经验或参与情况（如有）。
              <span class="limit-hint">字数上限为7500个字符，包括空格。（建议200words）</span>
            </span>
            <el-input 
              type="textarea" 
              :rows="6" 
              v-model="formData.research.experience" 
              maxlength="7500" 
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 4.2 -->
          <el-form-item prop="research.topicAbstract">
            <span slot="label" class="question-label">
              2. 请描述您提出的研究主题。
              <span class="limit-hint">字数上限为500个字符，包括空格。（建议100words）</span>
            </span>
            <div class="helper-text">描述内容应包括研究的一般领域以及具体的研究问题。</div>
            <el-input 
              type="textarea" 
              :rows="4" 
              v-model="formData.research.topicAbstract" 
              maxlength="500" 
              show-word-limit
            ></el-input>
          </el-form-item>
  
          <!-- 4.3 -->
          <el-form-item prop="research.detailedPlan">
            <span slot="label" class="question-label">
              3. 请描述您提出的研究计划。如果适用，请提供参考文献或引文。
              <span class="limit-hint">字数上限为7500个字符，包括空格。（建议800words）</span>
            </span>
            <div class="helper-text">
              描述内容应包括项目的具体目标与目的；研究方法或途径；您在研究项目中的经验或参与情况；以及支持该研究工作可行性的初步研究成果（如有的话）；此外，还应当说明该研究的意义、创新性以及预期产生的影响。
            </div>
            <el-input 
              type="textarea" 
              :rows="12" 
              v-model="formData.research.detailedPlan" 
              maxlength="7500" 
              show-word-limit
            ></el-input>
          </el-form-item>
        </div>
  
        <!-- Submit Area -->
        <!-- <div class="form-footer">
          <el-button type="primary" size="medium" @click="submitForm('hkpfsForm')">提交申请</el-button>
          <el-button size="medium" @click="resetForm('hkpfsForm')">重置</el-button>
        </div> -->
  
      </el-form>
      <HBFixedButton desc="_" @click="submitForm('hkpfsForm')"/>
    </div>
  </template>
  
  <script>
    import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
    import { getUserInfoApi,updateUserInfoApi } from '@/api/mycenter_studyabroad.js';
  export default {
    name: 'HKPFSForm',
    components: {
      HBFixedButton
    },
    data() {
      return {
        loading:false,
        type:'phd_3',
        // 数据对象
        formData: {
          // 1. 志愿
          choice1: {
            university: '',
            program: '',
            stream: '',
            supervisor: ''
          },
          choice2: {
            university: '',
            program: '',
            stream: '',
            supervisor: ''
          },
          // 2. 核心信息
          researchTitle: '',
          keywords: '',
          // 3. 文书 (Vision)
          vision: {
            reasons: '',
            career: '',
            contribution: '',
            other: ''
          },
          // 4. 研究 (Particulars)
          research: {
            experience: '',
            topicAbstract: '',
            detailedPlan: ''
          }
        },
        // 校验规则
        rules: {
          'choice1.university': [{ required: true, message: '请填写学校名称', trigger: 'blur' }],
          'choice1.program': [{ required: true, message: '请填写专业', trigger: 'blur' }],
          researchTitle: [{ required: true, message: '请填写研究title', trigger: 'blur' }],
          keywords: [
            { required: true, message: '请填写Keywords', trigger: 'blur' },
            { max: 100, message: '不超过100个字符', trigger: 'blur' }
          ],
          'vision.reasons': [{ required: true, message: '此项必填', trigger: 'blur' }],
          'vision.career': [{ required: true, message: '此项必填', trigger: 'blur' }],
          'research.detailedPlan': [{ required: true, message: '此项必填', trigger: 'blur' }]
        }
      };
    },
    mounted() {
    this.requestGetUserInfo();
  },
    methods: {
      requestSubmitUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId,
        data:{
          ...this.formData
        }
      };
      updateUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success('信息提交成功');
          window.location.reload();
        }
      }).catch(err => {
        console.error('提交用户信息失败:', err);
        this.$message.error(err.message || '提交用户信息失败');
      });
    },
    requestGetUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId
      };
      this.loading = true;
      getUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          let data = {}
          try {
            if (res.data && res.data.raw_data) {
              data = JSON.parse(res.data.raw_data);
            }
          } catch (e) {
          }

          // this.formData = {
          //   choice1: {
          //     university: data.choice1 ? data.choice1.university : '',
          //     program: data.choice1 ? data.choice1.program : '',//data.choice1?.program || '',
          //     stream:  //data.choice1?.stream || '',
          //     supervisor: data.choice1?.supervisor || ''
          //   },
          //   choice2: {
          //     university: data.choice2?.university || '',
          //     program: data.choice2?.program || '',
          //     stream: data.choice2?.stream || '',
          //     supervisor: data.choice2?.supervisor || ''
          //   },
          //   researchTitle: data.researchTitle || '',
          //   keywords: data.keywords || '',
          //   vision: {
          //     reasons: data.vision?.reasons || '',
          //     career: data.vision?.career || '',
          //     contribution: data.vision?.contribution || '',
          //     other: data.vision?.other || ''
          //   },
          //   research: {
          //     experience: data.research?.experience || '',
          //     topicAbstract: data.research?.topicAbstract || '',
          //     detailedPlan: data.research?.detailedPlan || ''
          //   }
          // };
          this.formData = {
            choice1: {
              university: data.choice1.university || '',
              program: data.choice1.program || '',
              stream: data.choice1.stream || '',
              supervisor: data.choice1.supervisor || ''
            },
            choice2: {
              university: data.choice2.university || '',
              program: data.choice2.program || '',
              stream: data.choice2.stream || '',
              supervisor: data.choice2.supervisor || ''
            },
            researchTitle: data.researchTitle || '',
            keywords: data.keywords || '',
            vision: {
              reasons: data.vision.reasons || '',
              career: data.vision.career || '',
              contribution: data.vision.contribution || '',
              other: data.vision.other || ''
            },
            research: {
              experience: data.research.experience || '',
              topicAbstract: data.research.topicAbstract || '',
              detailedPlan: data.research.detailedPlan || ''
            }
          }
        }

      }).catch(err => {
        console.error('获取用户信息失败:', err);
        this.$message.error(err.message || '获取用户信息失败');
      }).finally(() => {
        this.loading = false;
      });
    },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log('提交的数据:', this.formData);
            // this.$message.success('校验通过，正在提交...');
            this.requestSubmitUserInfo();
          } else {
            this.$message.error('请完善表单信息');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  };
  </script>
  
  <style scoped>
  .hkpfs-form-container {
    max-width: 960px;
    margin: 30px auto;
    padding: 40px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  }
  
  .main-title {
    text-align: center;
    margin-bottom: 40px;
    border-bottom: 2px solid #003366;
    padding-bottom: 15px;
  }
  
  .main-title h2 {
    color: #003366;
    margin: 0;
  }
  
  .form-section {
    margin-bottom: 40px;
  }
  
  .section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-left: 4px solid #003366;
    padding-left: 10px;
    margin-bottom: 20px;
    background-color: #f9f9f9;
    padding-top: 8px;
    padding-bottom: 8px;
  }
  
  .section-title .subtitle {
    font-size: 13px;
    color: #909399;
    font-weight: normal;
    margin-left: 10px;
  }
  
  /* 志愿卡片 */
  .choice-card /deep/ .el-card__header {
    padding: 10px 20px;
    background-color: #f5f7fa;
  }
  
  .choice-badge {
    display: inline-block;
    background-color: #409EFF;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
  }
  
  .choice-badge.secondary {
    background-color: #67C23A;
  }
  
  /* 题目标签 */
  .question-label {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    line-height: 1.4;
    display: block; /* 改为block以支持多行显示 */
    margin-bottom: 5px;
  }
  
  /* 限制提示颜色 */
  .limit-hint {
    font-size: 13px;
    color: #E6A23C;
    font-weight: normal;
    margin-left: 5px;
  }
  
  /* 辅助说明文字 */
  .helper-text {
    font-size: 13px;
    color: #606266;
    margin-bottom: 8px;
    line-height: 1.6;
    background: #f4f4f5;
    padding: 8px 12px;
    border-radius: 4px;
  }
  
  .form-footer {
    text-align: center;
    margin-top: 50px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
  }
  </style>


// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_phd_3.vue